import React from 'react';

import Skeleton from '@/components/common-components/SaralSkeleton';

import { SocialListeningTableItem } from './ContentListTableItem';

const ContentListTableItemSkeleton = () => {
  return (
    <tr className="">
      {/* Media thumbnail */}
      <SocialListeningTableItem>
        <Skeleton width={32} height={32} borderRadius={2} />
      </SocialListeningTableItem>

      {/* Type tag */}
      <SocialListeningTableItem>
        <Skeleton width={24} height={24} borderRadius={2} className="ml-2" />
      </SocialListeningTableItem>

      {/* Influencer name */}
      <SocialListeningTableItem>
        <Skeleton width={240} height={20} />
      </SocialListeningTableItem>

      {/* Influencer username */}
      <SocialListeningTableItem>
        <Skeleton width={180} height={20} />
      </SocialListeningTableItem>

      {/* Date */}
      <SocialListeningTableItem>
        <Skeleton width={100} height={20} />
      </SocialListeningTableItem>

      {/* Impressions */}
      <SocialListeningTableItem>
        <Skeleton width={48} height={20} className="mini-stat" />
      </SocialListeningTableItem>

      {/* Comments */}
      <SocialListeningTableItem>
        <Skeleton width={48} height={20} className="mini-stat" />
      </SocialListeningTableItem>

      {/* Likes */}
      <SocialListeningTableItem>
        <Skeleton width={48} height={20} />
      </SocialListeningTableItem>

      {/* Usage request button */}
      <SocialListeningTableItem>
        <Skeleton width={100} height={20} />
      </SocialListeningTableItem>

      {/* Labels */}
      <SocialListeningTableItem>
        <Skeleton width={48} height={20} />
      </SocialListeningTableItem>

      {/* Actions */}
      <SocialListeningTableItem>
        <Skeleton width={100} height={20} className="mini-stat" />
      </SocialListeningTableItem>
    </tr>
  );
};

export default ContentListTableItemSkeleton;
